import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const services = [{
  title: "מרכז רפואי קפלן",
  description: "אנו מספקים שירותי סיעוד והשגחה פרטית בבית החולים קפלן ברחובות. הצוות המקצועי שלנו זמין למתן מענה מיידי למאושפזים, תוך ליווי אישי וצמוד המבטיח שקט נפשי למשפחה וטיפול מסור למטופל בכל שעות היממה.",
  link: "/NursingCareProviderRehovotPage",
  linkText: "למידע על שירות בקפלן"
}, {
  title: "מרכז רפואי אסף הרופא",
  description: "שירותי מטפל סיעודי פרטי בבית החולים אסף הרופא (שמיר). אנו מתמחים בסיוע לאחר ניתוחים, השגחה לילית ותמיכה רגשית ופיזית. המטפלים שלנו מגיעים לבית החולים תוך זמן קצר כדי להעניק את הטיפול הטוב ביותר.",
  link: "/NursingCareProviderRehovotPage",
  linkText: "למידע על שירות באסף הרופא"
}];
export default function RelatedServicesCards() {
  return <section data-section-id="260469" id="מיקומים-וביתנות-ברחובות" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-5xl">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8">
            {services.map((service, i) => <Card key={i} data-index={i} className="bg-card text-card-foreground flex flex-col border-border shadow-md transition-transform duration-300 hover:-translate-y-1 rounded-lg">
                <CardHeader>
                  <CardTitle className="font-default text-primary text-2xl md:text-3xl">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <p className="font-default text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
                <CardFooter>
                  <Button asChild variant="outline" className="border-chart-2 text-chart-2 hover:bg-chart-2 hover:text-primary-foreground w-full sm:w-auto rounded-md">
                    <Link to={service.link}>
                      {service.linkText}
                      <ArrowRight className="mr-2 size-4 rotate-180" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}